"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'microphone.access.denied': 'Accesso al microfono negato. Per favore consenti l\'accesso al microfono per usare le funzioni vocali.',
};
